import React, { useState } from "react";

//  Style //
import "./SearchBar.css";
import { convertDateFormat } from "../../../utils/dateUtils";

const SearchBar = ({ onChange, value, type, width, placeholder, marginLeft, minDate, showUpcomingDates = false }) => {

  const [focus, setFocus] = useState(false);

  const minValue = () => {
    if (minDate) return minDate;
    if (showUpcomingDates) return new Date().toISOString().split('T')[0];
    return null;
  }

  return (
    <div className={`search_cont ${focus ? 'focused' : ''}`} style={{
      width: width ? width : '', marginLeft: marginLeft ? marginLeft : ''
    }}>
      {
        type === "date" ? '' : (<i className="fa-solid fa-magnifying-glass"></i>)
      }
      <input type={type} min={minValue()} onFocus={() => setFocus(true)} onBlur={() => setFocus(false)} placeholder={placeholder} value={value} onChange={(e) => onChange(e.target.value)} style={{
        width: type === "date" ? '93%' : ('87%')
      }} />
      {
        type === "date" ? (<i className="fa-regular fa-calendar-days"></i>) : ''
      }

    </div>
  );
};

export default SearchBar;
